export function generateDayWiseTimeSeries(baseval, count, yrange) {
    let i = 0;
    const series = [];
    while (i < count) {
        const x = baseval;
        const y =
            Math.floor(Math.random() * (yrange.max - yrange.min + 1)) +
            yrange.min;
        series.push([x, y]);
        baseval += 86400000; // Add one day in milliseconds
        i++;
    }
    return series;
}
export function buildPayloadFromEntity({ entity, data, formName = null }) {
    const payload = {};
    const grouped = {};

    if (!entity) return payload;

    let fields;

    if (formName && entity[formName]) {
        fields = entity[formName];
    } else {
        fields = entity.fields;
    }

    if (!fields || !Array.isArray(fields)) {
        return payload;
    }

    // Agrupa por path
    fields.forEach(field => {
        if (!field.path) return;

        if (!grouped[field.path]) grouped[field.path] = [];
        grouped[field.path].push(field);
    });

    // MONTA PAYLOAD
    Object.entries(grouped).forEach(([path, groupedFields]) => {
        const separator = groupedFields[0].concatWith || " ";

        const values = groupedFields
            .map(f => {
                let value = data[f.key];

                // Se vier como objeto reativo ou select (value interno)
                if (value && typeof value === "object" && "value" in value) {
                    value = value.value;
                }

                // 🔥 Correção — type activeSwitch sempre vira boolean
                if (f.type === "activeSwitch") {
                    return value === true || value === "true"; // retorna boolean sempre
                }

                // Se for objeto → mantém objeto real
                if (value !== undefined && value !== null) {
                    if (typeof value === "object") {
                        try {
                            return JSON.parse(JSON.stringify(value));
                        } catch {
                            return value;
                        }
                    }
                    return String(value).trim();
                }

                return "";
            })
            .filter(v => v !== "" && v !== null && v !== undefined);

        if (values.length === 0) return;

        const finalValue =
            values.length > 1 ? values.join(separator).trim() : values[0];

        // Monta chave no payload
        const keys = path.split(".");
        let current = payload;

        keys.forEach((key, index) => {
            if (index === keys.length - 1) {
                current[key] = finalValue;
            } else {
                if (!current[key]) current[key] = {};
                current = current[key];
            }
        });

    });

    return payload;
}

export function populateFormFromEntity(entity, apiData) {
    const form = {};

    entity.fields.forEach(field => {
        if (!field.path) return;

        const keys = field.path.split(".");
        let current = apiData;

        for (const key of keys) {
            if (current && typeof current === "object") {
                current = current[key];
            } else {
                current = undefined;
                break;
            }
        }

        if (typeof current === "string" && field.concatWith) {
            const parts = current.split(field.concatWith);
            const relatedFields = entity.fields.filter(f => f.path === field.path);

            relatedFields.forEach((f, index) => {
                form[f.key] = parts[index]?.trim() ?? "";
            });
        } else if (!field.concatWith) {
            if (typeof current === "boolean" || typeof current === "number") {
                form[field.key] = current;
            } else if (current === null || current === undefined) {
                form[field.key] = "";
            } else {
                form[field.key] = current;
            }
        }
    });
    return form;
}

export async function searchAndSetOptions({
      key,
      apiFn,
      query,
      entity,
      isFetching,
      mapFn = (item) => ({
          value: item.id,
          label: item.name,
          corpId: item?.corp_id
      }),
      advancedFilter = false,
      formName = "",
      searchParam = "name"
    }) {

    let fields;
    if (advancedFilter) {
        fields = entity.value.pages?.list?.filters?.advanced?.fields || [];
    } else if (formName && entity.value[formName]) {
        fields = entity.value[formName];
    }
    else {
        fields = entity.value.fields || [];
    }
    let field = [];
    field = fields.find(f => f.key === key);

    if (!field) return;

    if (!query) {
        field.options = [];
        return;
    }

    try {
        isFetching.value = true;
        const response = await apiFn({
            [searchParam]: `%${query}%`,
            status: true,
        });

        const data = Array.isArray(response) ? response : response.data;

        field.options = Array.isArray(data)
            ? data.map(mapFn)
            : [];

    } catch (error) {
        console.error(`Erro ao buscar dados para ${key}:`, error);
        field.options = [];
    } finally {
        isFetching.value = false;
    }
}

export function setFieldOptions(entity, key, options) {
    if (!entity?.value?.fields) return;

    const field = entity.value.fields.find(f => f.key === key);
    if (field) {
        field.options = options;
    }
}

export function  blockLetters (e) {
    const allowed = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab']
    if (allowed.includes(e.key)) return
    if (!/[0-9]/.test(e.key)) e.preventDefault()
}

export function  formatCpfCnpj (value = '') {
    let digits = value.replace(/\D/g, '').slice(0, 14)

    if (digits.length <= 11) {
        return digits
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
    }

    return digits
        .replace(/^(\d{2})(\d)/, '$1.$2')
        .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1/$2')
        .replace(/(\d{4})(\d{1,2})$/, '$1-$2')
        .slice(0, 18)
}

export function  formatPhone (value = '') {
    let digits = value.replace(/\D/g, '').slice(0, 11)

    if (digits.length > 10) {
        return digits
            .replace(/^(\d{2})(\d)/, '($1) $2')
            .replace(/(\d{5})(\d{4})$/, '$1-$2')
    }

    return digits
        .replace(/^(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{4})(\d{4})$/, '$1-$2')
}
